import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
var moment = require("moment");
import DatePicker from "vue2-datepicker";
import KvUserSelectMultiple from "@/components/kiva/KvUserSelectMultiple";
import tasksMixin from "@/mixins/tasks.js";
import defaultMixin from "@/mixins/task/default.js";
import settingsMixin from "@/mixins/settings.js";
import labelMixin from "@/mixins/labels";
// import usersMixin from "~/mixins/users.js";
import { VueEditor } from "vue2-editor";
var requests = require("@/utils/requests").default;
import VueTribute from "vue-tribute";
import InboxModal from "@/views/inbox/components/InboxModal";
var VueScrollTo = require("vue-scrollto");
import ClickOutside from "vue-click-outside";
import { ActTaskTransformer } from "@/transformers/ActTaskTransformer";
import optionsMixin from "@/mixins/options";
import "vue2-datepicker/index.css";
import SvgIcon from "@/components/kiva/kvSvgIcon.vue";
import { ActProjectTransformer } from "@/transformers/ActProjectTransformer";
export default {
  name: "taskEditModal",
  mixins: [tasksMixin, settingsMixin, defaultMixin, optionsMixin, labelMixin],
  props: {
    task: Object,
    selected_project: [Object, Array],
    isRefresh: {
      type: Boolean,
      default: false
    },
    thread: {
      type: Number,
      default: null
    },
    setShowSearch: Boolean
  },
  components: {
    KvUserSelectMultiple: KvUserSelectMultiple,
    VueEditor: VueEditor,
    VueTribute: VueTribute,
    DatePicker: DatePicker,
    taskFormDependency: function taskFormDependency() {
      return import("@/components/tasks/main/forms/taskFormDependency");
    },
    userRecordOwner: function userRecordOwner() {
      return import("@/components/kiva/KvUserSelect");
    },
    kvEmployee: function kvEmployee() {
      return import("@/components/kiva/remote-search/kvEmployee");
    },
    vueMention: function vueMention() {
      return import("@/components/tasks/main/widgets/vue_mention");
    },
    subTasks: function subTasks() {
      return import("@/components/tasks/main/forms/subTasks");
    },
    // dueDatePicker: () => import('@/components/tasks/main/forms/dueDatePicker'),
    timeEntry: function timeEntry() {
      return import("@/components/tasks/timeEntry/timeEntryForm");
    },
    sectionForm: function sectionForm() {
      return import("@/components/tasks/section/sectionForm");
    },
    attachments: function attachments() {
      return import("@/components/tasks/main/attachments");
    },
    noteList: function noteList() {
      return import("@/components/global/kvNoteList");
    },
    KvUser: function KvUser() {
      return import("@/components/kiva/KvUser");
    },
    kvLoading: function kvLoading() {
      return import("@/components/kiva/static/loading");
    },
    editLabels: function editLabels() {
      return import("@/components/tasks/main/labels");
    },
    CounterActionButton: function CounterActionButton() {
      return import("@/components/Items/TimeCounter/CounterActionButton");
    },
    kvLabelInput: function kvLabelInput() {
      return import("@/components/kiva/input/kvLabelInput");
    },
    kvDateRange: function kvDateRange() {
      return import("@/components/kiva/kvDateRangeCompact");
    },
    KvTimeSelect: function KvTimeSelect() {
      return import("@/components/kiva/KvTimeSelectWidePop");
    },
    SvgIcon: SvgIcon,
    KvProject: function KvProject() {
      return import("@/components/kiva/remote-search/kvProject");
    },
    MergeThreadModal: function MergeThreadModal() {
      return import("@/views/inbox/components/MergeTaskToThread");
    },
    InboxModal: InboxModal
  },
  directives: {
    ClickOutside: ClickOutside
  },
  data: function data() {
    return {
      oldTaskStatusTriggerChange: {
        value: null,
        label: ""
      },
      dateChangePermission: true,
      showMergeThreadModal: false,
      smallSizeBox: false,
      editModal: false,
      subTasksLoading: false,
      failed: false,
      hasChanged: false,
      loading: false,
      isOpen: false,
      dialogTableVisible: false,
      editLabelsModal: false,
      created: false,
      buttonsDisabled: false,
      any_change: false,
      changeNeedRefresh: false,
      timeoutData: null,
      fromVisible: {},
      dependency_list: [],
      attachmentsList: [],
      subTasks: [],
      unRecordedLabels: [],
      visibleTimeSelector: false,
      labels: [],
      taskData: {},
      taskDataOriginal: {},
      projectData: {},
      basic_task: {},
      focus: false,
      project_section: [],
      fieldVisible: {
        description: false,
        subTasks: false,
        documents: false,
        dependency: false,
        labels: false
      },
      selectedLabels: [],
      configOptions: {
        plugins: ["clips", "fontsize", "fullscreen", "table", "inlinestyle"],
        buttonsHide: ["html", "align", "strikethrough"],
        buttons: ["redo", "undo", "format", "bold", "italic", "lists", "image", "file", "link", "clips"],
        editor: {
          focus: false,
          height: "200px"
        }
      },
      oldTaskData: {},
      isDependencyFound: false,
      project_type: "1",
      priority: [],
      approval_status: [],
      old_task_status: {},
      is_show_selected_dependency: false,
      dependency_key: "dependency_key",
      documents_key: "documents_key",
      modal_key: "modal_key",
      show_selected_dependency: {},
      selected_time_entry: {},
      is_show_time_entry: false,
      time_entry_key: "time_entry_key",
      oldDescription: "",
      taskContentChanged: null,
      typeOptions: [{
        value: 1,
        label: this.$t("Task")
      }, {
        value: 2,
        label: this.$t("Approval")
      }, {
        value: 3,
        label: this.$t("Issue")
      }]
    };
  },
  methods: {
    checkStatusThenSave: function checkStatusThenSave() {
      var status = this.taskData.task_status.value;
      if (status == 5) {
        this.showPrompt();
      } else {
        this.taskData.hold_reason = "";
        this.triggerSaveTask();
        this.changeNeedRefresh = true;
      }
    },
    showPrompt: function showPrompt() {
      var _this = this;
      var changeStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      // console.log("valuec","x",this.oldTaskStatusTriggerChange)
      this.$prompt(this.$t("Please enter hold reason"), this.$t("Type hold reason"), {
        confirmButtonText: this.$t("Save"),
        cancelButtonText: this.$t("Cancel"),
        inputValue: this.taskData.hold_reason
      }).then(function (_ref) {
        var value = _ref.value;
        if (value != "" && value.length > 1) {
          _this.taskData.hold_reason = value;
          _this.triggerSaveTask();
          _this.changeNeedRefresh = true;
          _this.$refs.status_select.blur();
        } else {
          _this.taskData.task_status.value = _this.oldTaskStatusTriggerChange.value;
          _this.taskData.task_status.label = _this.oldTaskStatusTriggerChange.label;
          _this.$refs.status_select.blur();
        }
      }).catch(function (err) {
        if (changeStatus) {
          // console.log("err", err, this.oldTaskStatusTriggerChange);
          _this.taskData.task_status.value = _this.oldTaskStatusTriggerChange.value;
          _this.taskData.task_status.label = _this.oldTaskStatusTriggerChange.label;
          _this.$refs.status_select.blur();
        }
      });
    },
    control_dmy: function control_dmy() {
      var ddson = this.taskData.due_date_scheduled_on;
      var diff = moment().diff(moment(ddson), "hours");
      if (diff > 24) {
        return false;
      } else {
        return true;
      }
    },
    showPromptRescheduleReason: function showPromptRescheduleReason($event) {
      var _this2 = this;
      this.$prompt(this.$t("Please enter rescheduling reason"), this.$t("Type rescheduling reason"), {
        confirmButtonText: this.$t("Save"),
        cancelButtonText: this.$t("Cancel"),
        inputValue: this.taskData.rescheduling_reason
      }).then(function (_ref2) {
        var value = _ref2.value;
        if (value != "" && value.length > 1) {
          _this2.taskData.rescheduling_reason = value;
          if ($event) {
            _this2.mergeTaskData($event);
          }
          _this2.changeNeedRefresh = true;
        }
      }).catch(function (err) {
        _this2.taskData.end_date_dmy = _this2.taskDataOriginal.end_date_dmy;
      });
    },
    openCustomerComments: function openCustomerComments(data) {
      this.$store.dispatch("app/activateDrawer", {
        show: true,
        tab: "crmComment",
        options: {
          record_id: this.taskData.record_id
        }
      });
    },
    editLabels: function editLabels() {
      this.editLabelsModal = true;
    },
    setButtonDisabled: function setButtonDisabled() {
      var _this3 = this;
      this.buttonsDisabled = true;
      setTimeout(function () {
        _this3.buttonsDisabled = false;
      }, 1500);
    },
    mergeTaskData: function mergeTaskData(newTaskData) {
      Object.assign(newTaskData);
      //  taskData.start_date=$event[0];taskData.end_date_dmy=$event[1]
      this.dateChangePermission = this.control_dmy();
      if (this.dateChangePermission || this.taskData.rescheduling_reason) {
        newTaskData = [newTaskData, newTaskData];
        this.taskData.start_date = !newTaskData[0] || newTaskData[0] == "Invalid date" ? "" : moment(newTaskData[0]).format("YYYY-MM-DD");
        this.taskData.start_date_dmy = !newTaskData[0] || newTaskData[0] == "Invalid date" ? "" : moment(newTaskData[0]).format("YYYY-MM-DD");
        this.taskData.end_date = !newTaskData[1] || newTaskData[1] == "Invalid date" ? "" : moment(newTaskData[1]).format("YYYY-MM-DD");
        this.taskData.end_date_dmy = !newTaskData[1] || newTaskData[1] == "Invalid date" ? "" : moment(newTaskData[1]).format("YYYY-MM-DD");
        if (!this.taskData.record_id && this.taskData.end_date_dmy && this.taskData.task_status.value == 6) {
          this.taskData.task_status = {
            value: 1,
            label: "Open"
          };
        } else if (this.taskData.start_date == "" && this.taskData.end_date == "") {
          this.taskData.task_status = {
            value: 6,
            label: "Backlog"
          };
        }
        this.triggerSaveTask();
      } else {
        this.showPromptRescheduleReason(newTaskData);
      }
      // this.taskPlan = newTaskData.taskPlan;
    },
    WorkPermission: function WorkPermission() {
      if (this.taskData.record_owner && this.taskData.record_owner.value && this.taskData.record_owner.value == this.$store.state.users.CURRENT_USER.userId) {
        return true;
      }
      if (this.taskData.support_assignees) {
        var sup_as = this.taskData.support_assignees.split(",");
        var stringId = "" + this.$store.state.users.CURRENT_USER.userId;
        if (sup_as && sup_as[0] && sup_as.includes(stringId)) {
          return true;
        }
      }
    },
    chooseRef: function chooseRef(field) {
      var _this4 = this;
      setTimeout(function () {
        _this4.$refs[field].focus();
      }, 600);
    },
    scrollTo: function scrollTo(id) {
      var options = {
        container: "#commentsContainer",
        easing: "ease-in",
        offset: -10,
        force: true
      };
      var duration = 500;
      VueScrollTo.scrollTo("#commentField", duration, options);
    },
    triggerSaveTask: function triggerSaveTask() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      // console.log("input", input);
      if (input == "followers") {
        this.taskData.followers_array = this.taskData.followers.map(function (k) {
          return k.value ? k.value : null;
        });
      }
      this.setButtonDisabled();
      this.startSaveTask();
      this.hasChanged = false;
    },
    startSaveTask: function startSaveTask() {
      if (this.taskData.record_id) {
        this.setButtonDisabled();
        if (typeof this.taskData.task_status != "undefined" && this.taskData.task_status && (this.taskData.task_status.value == 3 || this.taskData.task_status == 3)) {
          this.change_task_to_completed();
        } else {
          this.save_task(_objectSpread(_objectSpread({}, this.taskData), {}, {
            unRecordedLabels: this.unRecordedLabels
          }), "standart", this.isRefresh, this.task);
          this.oldTaskData = _objectSpread({}, this.taskData);
        }
      }
    },
    showField: function showField(field) {
      this.fieldVisible[field] = true;
      if (field == "dependency") {
        this.is_show_selected_dependency = true;
        this.show_selected_dependency = {};
        this.dependency_key = Math.random(100, 99999);
      }
    },
    findVisibility: function findVisibility(type) {
      if (type == "description") {
        return !this.taskData.description && !this.fieldVisible.description ? true : false;
      } else if (type == "sub_tasks") {
        return this.taskData.sub_tasks == "0/0" && !this.fieldVisible.sub_tasks ? true : false;
      } else if (type == "dependency") {
        return this.taskData.dependency_count == "0/0" && !this.fieldVisible.dependency ? true : false;
      } else if (type == "documents") {
        return !this.fieldVisible.documents ? true : false;
      } else if (type == "labels") {
        return !this.fieldVisible.labels ? true : false;
      }
    },
    deleteConfirm: function deleteConfirm() {
      var _this5 = this;
      this.$confirm(this.$t("This will permanently delete the task"), "Warning", {
        confirmButtonText: this.$t("OK"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this5.taskData.task_status.value = 4;
              _context.next = 3;
              return _this5.delete_task(_this5.taskData, _this5.isRefresh);
            case 3:
              // this.$message({
              //   type: 'success',
              //   message: this.$t('Delete completed')
              // })
              delete _this5.task;
              Object.assign(_this5.task, {
                removed: true,
                record_id: null,
                subject: "",
                project: {
                  value: null
                },
                record_owner: {
                  value: null
                }
              });
              _this5.$emit("setEvent", {
                command: "filter"
              });
              _this5.changeNeedRefresh = true;
              _this5.set_updates(true);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        _this5.$message({
          type: "info",
          message: _this5.$t("Delete canceled")
        });
      });
    },
    find_project_type: function find_project_type() {
      var project = this.taskData.project ? this.taskData.project.value : "";
      var projects = this.$store.state.project.projects_formated;
      var ptype = projects.filter(function (k) {
        return k.id == project;
      });
      this.project_type = ptype[0] ? ptype[0].time_entry_req : "??";
      this.taskData.project_type = this.project_type;
    },
    start_add_time_entry: function start_add_time_entry() {
      this.$store.dispatch("app/activateDrawer", {
        show: true,
        tab: "logTimeEntry",
        options: {
          data: {
            task: {
              value: this.taskData.record_id,
              label: this.taskData.subject
            },
            project: this.taskData.project
          }
        }
      });
    },
    start_add_time_entry_edit: function start_add_time_entry_edit(row) {
      // console.log("row",row)
      this.$store.dispatch("app/activateDrawer", {
        show: true,
        tab: "logTimeEntry",
        options: {
          record_id: row.act_time_entry_id
        }
      });
    },
    save_task_first_time: function save_task_first_time(action) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this6.taskData.attachmentsList = _toConsumableArray(_this6.attachmentsList);
              _this6.hasChanged = false;
              _context2.next = 4;
              return _this6.save_task(_this6.taskData, "standart", _this6.isRefresh, _this6.task);
            case 4:
              _context2.next = 6;
              return _this6.saveUncordedLabels(_this6.taskData.record_id, "act", "task", _this6.unRecordedLabels);
            case 6:
              if (action == "saveAndCreateNew") {
                _this6.taskData = _objectSpread({}, _this6.basic_task);
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save_task_first_time_forced: function save_task_first_time_forced() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this7.taskData.subject) {
                _context3.next = 6;
                break;
              }
              _this7.hasChanged = false;
              _context3.next = 4;
              return _this7.save_task(_this7.taskData, "standart", _this7.isRefresh, _this7.task);
            case 4:
              _context3.next = 7;
              break;
            case 6:
              _this7.$message({
                message: _this7.$t("Subject field should not be null."),
                type: "warning"
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    change_task_to_completed: function change_task_to_completed() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var old_task_status;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              old_task_status = _this8.taskData.task_status;
              _this8.changeNeedRefresh = true;
              _this8.taskData.task_status = {
                value: "3",
                label: _this8.$t("Completed")
              };
              _this8.old_task_status = old_task_status;
              _context4.next = 6;
              return _this8.save_task(_this8.taskData, "standart", _this8.isRefresh, _this8.task);
            case 6:
              _this8.set_updates(true);
              _this8.setButtonDisabled();
              //   this.set_updates();
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    saveTaskDescription: function saveTaskDescription() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var record_id, params;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              record_id = _this9.taskData.record_id;
              _this9.saving = true;
              params = {
                record_id: record_id,
                description: _this9.taskData.description
              };
              _this9.$store.commit("savingStart", {
                status: 1
              });
              _context5.next = 6;
              return new KivaProxy({
                endpoint: "act/task"
              }).update(params).then(function (rtn) {
                if (rtn.status == "Success") {
                  _this9.$store.commit("savingEnd", {
                    status: 2,
                    result: {
                      app: "act",
                      modul: "task",
                      recordId: record_id,
                      time: moment().format("DD-MM-YYYY HH:mm:ss")
                    }
                  });
                } else {
                  _this9.$store.commit("savingEnd", {
                    status: 3,
                    result: {
                      app: "act",
                      modul: "task",
                      recordId: record_id,
                      time: moment().format("DD-MM-YYYY HH:mm:ss")
                    }
                  });
                }
                setTimeout(function () {
                  _this9.saving = false;
                }, 700);
              }).catch(function (err) {
                _this9.$store.commit("savingEnd", {
                  status: 3,
                  result: {
                    app: "act",
                    modul: "task",
                    recordId: record_id,
                    time: moment().format("DD-MM-YYYY HH:mm:ss")
                  }
                });
                setTimeout(function () {
                  _this9.saving = false;
                }, 700);
              });
            case 6:
              return _context5.abrupt("return", _context5.sent);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    change_task_to_open: function change_task_to_open() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var old_task_status, params;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              old_task_status = _this10.taskData.task_status;
              _this10.changeNeedRefresh = true;
              _this10.taskData.task_status = {
                value: "1",
                label: "Açık"
              };
              _this10.old_task_status = old_task_status;
              // await this.save_task(this.taskData, 'standart', this.isRefresh, this.task)
              // this.set_updates()
              params = {
                task_status: 1,
                record_id: _this10.taskData.record_id
              };
              _this10.setButtonDisabled();
              _context6.next = 8;
              return new KivaProxy({
                endpoint: "act/task"
              }).update(params).then(function (data) {
                if (data.success == true) {
                  _this10.$store.commit("savingEnd", {
                    status: 2,
                    result: {
                      app: "act",
                      modul: "task",
                      recordId: params.record_id,
                      time: moment().format("DD-MM-YYYY HH:mm:ss")
                    }
                  });
                }
              }).catch(function (err) {});
            case 8:
              return _context6.abrupt("return", _context6.sent);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    set_updates: function set_updates(force) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var r;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (_this11.created) {
                r = Math.floor(Math.random() * 1000);
                if (force && _this11.changeNeedRefresh) {
                  _this11.$emit("updateKey", "k" + r);
                }
                if (_this11.task && _this11.task.setActivityDrawer) {
                  _this11.$store.state.app.activityDrawer = true;
                }
                // await this.startSaveTask()

                if (_this11.changeNeedRefresh == true) {
                  _this11.$emit("updateKey", "k" + r);
                  setTimeout(function () {
                    _this11.$emit("updateShow", false);
                  }, 500);
                } else {
                  _this11.$emit("updateShow", false);
                }
                _this11.created = false;
              }
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    get_project_section: function get_project_section(change) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var projects_formated, pr, project_section;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this12.project_section = [];
              if (!(_this12.taskData.project && _this12.taskData.project.value)) {
                _context8.next = 9;
                break;
              }
              projects_formated = _this12.$store.state.project.projects_formated;
              pr = projects_formated.find(function (k) {
                return k.id == _this12.taskData.project.value;
              });
              _this12.taskData.project.name = pr ? pr.label : "?";
              _context8.next = 7;
              return requests.get_project_section({
                project: _this12.taskData.project.value
              });
            case 7:
              project_section = _context8.sent;
              _this12.project_section = project_section.records;
            case 9:
              _context8.next = 11;
              return _this12.find_project_type();
            case 11:
              // if project changed, it makes section null
              if (change) {
                _this12.taskData.section = {
                  value: null
                };
              }
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    total_time: function total_time(owner) {
      if (owner == "my") {
        owner = this.$store.state.users.CURRENT_USER.userId;
      }
      var all = this.all_time_entries;
      var total = 0;
      if (all && _typeof(all) == "object") {
        all.forEach(function (e) {
          if (owner) {
            if (owner == e.record_owner.value || owner == e.record_owner) {
              var h = e.hours * 60;
              var m = e.minutes;
              total += h + m;
            }
          } else {
            var _h = e.hours * 60;
            var _m = e.minutes;
            total += _h + _m;
          }
        });
      }
      var to = Math.floor(total / 60);
      var mi = Math.floor(total - to * 60);
      var ho = to ? to + "s " : "";
      var min = mi ? mi + "dk. " : "";
      return ho + " " + min;
    },
    getProject: function getProject(record_id) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this13.loading = true;
              // console.log("record_id",record_id)
              // console.log("act/project",record_id)
              _context9.next = 3;
              return new KivaProxy({
                endpoint: "act/project"
              }).setFields(["record_id", "avatar_image", "approval_required", "account_name", "project_name", "project_status", "project_group", "start_date", "description", "due_date", "follow_up_on", "record_owner", "team", "followers"]).find(record_id).then(function (response) {
                _this13.projectData = ActProjectTransformer.fetch(response.record, _this13.users);
                _this13.loading = false;
              }).catch(function (err) {
                _this13.loading = false;
              });
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    get_task: function get_task(taskId) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return new KivaProxy({
                endpoint: "act/task"
              }).setParameters({
                "checkNotes": 1,
                "checkAtc": 1
              }).setFields(["rescheduling_reason", "due_date_scheduled_on", "hold_reason", "status", "thread", "priority", "account_name", "visible_on_cp", "customer_comments_count", "customer_comments_done", "task_type", "spent_time", "time_enty_list", "subtask_list", "dependency_list", "time_entry_list", "created_on", "created_by", "last_modified_on", "last_modified_by", "overdue_duration", "support_assignees", "dependency_count", "subject", "expected_duration", "dependency", "allday", "photo", "task_results", "description", "followers", "sub_tasks", "section", "sub_task_list", "start_date", "end_date", "record_owner", "project", "task_status", {
                "project": ["project_status", "followers", "record_owner", "approval_required"]
              }]).find(taskId).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(response) {
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        _this14.taskData = ActTaskTransformer.fetch(response.record, _this14.users);
                        _this14.taskDataOriginal = _objectSpread({}, _this14.taskData);
                        _this14.all_time_entries = response.record.time_entry_list ? response.record.time_entry_list.map(function (k) {
                          var duration = k.duration / 60;
                          k.hours = Math.floor(duration / 60);
                          k.minutes = duration % 60;
                          k.record_owner = _this14.users.find(function (a) {
                            return a.userId == k.record_owner;
                          });
                          k.record_owner.value = k.record_owner.userId;
                          k.record_owner.label = k.record_owner.fullName;
                          k.duration_formatted = (k.hours > 0 ? k.hours + "h" : '') + (k.minutes > 0 ? k.minutes + "m" : '');
                          return k;
                        }) : [];
                        _this14.dependency_list = response.record.dependency_list;
                        if (response.record.project && response.record.project.value && response.record.relatedData.project) {
                          // await this.getProject(response.record.project.value);
                          //console.log("response.record.relatedData",response.record.relatedData.project)
                          _this14.projectData = ActProjectTransformer.fetch(response.record.relatedData.project, _this14.users);
                        }
                      case 5:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    starter: function starter() {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var projects;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              // console.log("task",this.task);
              // console.log("selected_project",this.selected_project);
              _this15.oldDescription = _this15.taskData.description;

              //If projects havent yet stored, start to get projects
              if (!(_this15.projects && (!_this15.projects[0] || _this15.projects && !_this15.projects[0]))) {
                _context12.next = 7;
                break;
              }
              _context12.next = 4;
              return requests.get_projects({
                project_status: 1
              });
            case 4:
              projects = _context12.sent;
              projects = projects.records;
              _this15.projects = projects;
            case 7:
              if (!_this15.taskData.project) {
                if (_this15.selected_project && _this15.selected_project.record_id) {
                  _this15.taskData.project = {
                    value: "" + _this15.selected_project.record_id,
                    label: "" + _this15.selected_project.project_name,
                    name: "" + _this15.selected_project.project_name
                  };
                } else {
                  _this15.taskData.project = {
                    value: null
                  };
                }
              }
              if (_this15.taskData && _this15.taskData.record_id && _this15.taskData.record_id != "") {
                _this15.list_notes();
                // this.list_time_entries(this.taskData.record_id, null, null, "TASK");
              }

              _this15.get_project_section(false);
              if (_this15.taskData.dependency && _this15.taskData.dependency.value && _this15.taskData.dependency.value != "") {
                _this15.taskData.dependency = _this15.taskData.dependency.value;
              }
              setTimeout(function () {
                _this15.loading = false;
              }, 350);
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    dataUriToBlob: function dataUriToBlob(dataURI) {
      // serialize the base64/URLEncoded data
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(dataURI.split(",")[1]);
      } else {
        byteString = unescape(dataURI.split(",")[1]);
      }

      // parse the mime type
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // construct a Blob of the image data
      var array = [];
      for (var i = 0; i < byteString.length; i++) {
        array.push(byteString.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {
        type: mimeString
      });
    }
  },
  computed: {
    users: function users() {
      return this.$store.state.users.USERS;
    },
    me: function me() {
      return _objectSpread({}, this.$store.state.users.CURRENT_USER);
    },
    projects: {
      get: function get() {
        return this.$store.state.project.projects;
      },
      set: function set(val) {
        this.$store.state.project.projects = val;
      }
    },
    lastUpdate: {
      get: function get() {
        return this.$store.state.lastUpdate;
      },
      set: function set(val) {
        this.$store.state.lastUpdate = val;
      }
    },
    editable: function editable() {
      return this.taskData.task_status && this.taskData.task_status && (this.taskData.task_status.value == 3 || this.taskData.task_status == 3) ? false : true;
    },
    tomorrow: function tomorrow() {
      var today = new Date();
      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return new Date(tomorrow);
    },
    task_status: {
      get: function get() {
        return this.$store.state.task_status;
      },
      set: function set(val) {
        // console.warning("Can not set task status!")
        // this.$store.state.task_status = val
      }
    }
  },
  created: function created() {
    var _this16 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var img, blob, thread_name, _thread_name, _thread_name2;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _this16.loading = true;
            moment.locale(_this16.$locale);
            _context13.next = 4;
            return Promise.all([_this16.getOptions({
              app: "act",
              model: "task",
              column: "task_status"
            }), _this16.getOptions({
              app: "act",
              model: "task",
              column: "approval_status"
            }), _this16.getOptions({
              app: "act",
              model: "task",
              column: "priority"
            })]);
          case 4:
            if (!_this16.task) {
              _context13.next = 24;
              break;
            }
            if (!_this16.task.record_id) {
              _context13.next = 10;
              break;
            }
            _context13.next = 8;
            return _this16.get_task(_this16.task.record_id);
          case 8:
            _context13.next = 21;
            break;
          case 10:
            _this16.set_basic_task_data();
            _this16.taskData = _objectSpread({}, _this16.basic_task);
            if (_this16.task && _this16.task.description) {
              _this16.taskData.description = _this16.task.description;
            }
            if (_this16.task && _this16.task.project) {
              _this16.taskData.project = _this16.task.project;
            }
            if (_this16.task && _this16.task.section) {
              _this16.taskData.section = _this16.task.section;
            }
            if (_this16.task && _this16.task.subject) {
              _this16.taskData.subject = _this16.task.subject;
            }
            if (_this16.task && _this16.task.recordOwner) {
              _this16.taskData.record_owner = {
                value: parseInt(_this16.task.recordOwner.value),
                label: _this16.task.recordOwner.label
              };
            }
            if (_this16.task && _this16.task.endDate) {
              _this16.taskData.end_date = _this16.task.endDate;
              _this16.taskData.end_date_dmy = moment(_this16.task.endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            // console.log("taskData",this.taskData);
            // console.log("this.task",this.task);

            if (_this16.task && _this16.task.task_type) {
              _this16.taskData.task_type = _this16.task.task_type;
            }
            if (_this16.task && _this16.task.startDate) {
              _this16.taskData.start_date = _this16.task.startDate;
              _this16.taskData.start_date_dmy = _this16.task.startDate;
              _this16.taskData.task_status.value = 1;
            }
            if (_this16.task.attachment) {
              img = _this16.task.attachment;
              blob = _this16.dataUriToBlob(img);
              blob.name = "captured_screenshot.png";
              _this16.attachmentsList = [blob];
              _this16.showField("documents");
            }
          case 21:
            _this16.oldTaskData = _objectSpread({}, _this16.taskData);
            _context13.next = 26;
            break;
          case 24:
            _this16.set_basic_task_data();
            _this16.taskData = _objectSpread({}, _this16.basic_task);
          case 26:
            setTimeout(function () {
              _this16.created = true;
            }, 500);

            // console.log("this.thread",this.thread,this.task.threadDetail)
            if (_this16.thread && _this16.thread != null) {
              _this16.taskData.thread = _this16.thread;
              if (!_this16.taskData.subject) {
                thread_name = _this16.thread ? _this16.thread.value ? _this16.thread.value : _this16.thread : ""; // console.log("2111 this.thread",this.thread)
                _this16.taskData.subject = "#" + thread_name;
              } else {}
              _this16.oldTaskData.thread = _this16.thread;
            } else if (_this16.task.threadDetail && _this16.task.threadDetail.record_id) {
              if (!_this16.taskData.subject) {
                _thread_name = _this16.task.threadDetail ? _this16.task.threadDetail.record_id + " " + _this16.task.threadDetail.subject : _this16.task.thread; // console.log("threadDetail this.thread",this.task.threadDetail)
                _this16.taskData.subject = "#" + _thread_name;
              } else {}
              _this16.taskData.thread = parseInt(_this16.task.threadDetail.record_id);
              _this16.oldTaskData.thread = parseInt(_this16.task.threadDetail.record_id);
            } else if (_this16.task.thread) {
              _this16.taskData.thread = parseInt(_this16.task.thread);
              if (!_this16.taskData.subject) {
                _thread_name2 = _this16.thread ? _this16.thread.value ? _this16.thread.value : _this16.thread : "";
                _this16.taskData.subject = "#" + _thread_name2;
              } else {}
              _this16.oldTaskData.thread = parseInt(_this16.task.thread);
            }
            _this16.starter();
            if (_this16.thread) {
              _this16.taskData.subject = "#" + _this16.thread;
            }
          case 30:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }))();
  },
  watch: {
    "lastUpdate.time": function lastUpdateTime(val) {
      this.list_time_entries(this.taskData.record_id, null, null, 'TASK');
    },
    "taskData.subject": function taskDataSubject(val) {
      this.hasChanged = true;
    },
    "taskData.task_status.value": function taskDataTask_statusValue(val, old) {
      // console.log(old, val);
      this.oldTaskStatusTriggerChange.value = old;
    },
    "taskData.description": function taskDataDescription(val) {
      var _this17 = this;
      if (val != this.oldDescription && this.oldDescription != "" && this.taskData.record_id) {
        var id = this.task.record_id;
        var storageName = "task_" + id;
        localStorage.setItem(storageName, this.taskData.description);
        if (this.timeoutData) {
          clearTimeout(this.timeoutData);
        }
        this.timeoutData = setTimeout(function () {
          _this17.saveTaskDescription();
        }, 3000);
        var nowMS = new Date();
        this.taskContentChanged = nowMS;
      }
    }
  }
};